import { Button, DialogActions, DialogTitle, Divider } from '@mui/material';
import { Trans } from 'react-i18next';
import { Project } from '../../Projects/projects';

interface RemoveCompleteShareCodeDialogProps {
  project: Project | null;
  onClose: () => void;
  open: boolean;
}

const RemoveCompleteShareCodeDialog = ({ onClose, project }: RemoveCompleteShareCodeDialogProps) => {
  const projectName = project?.name;

  return (
    <>
      <DialogTitle variant="dialogTitle" align="center" sx={{ overflowWrap: 'break-word' }}>
        <Trans i18nKey="removeCompleteShareCodeDialog.title">Share Code Removed for {{ projectName }}</Trans>
      </DialogTitle>
      <Divider />
      <DialogActions sx={{ justifyContent: 'center', px: 2, py: 1 }}>
        <Button onClick={onClose}>
          <Trans i18nKey="openShareCodeDialog.button.close">Close</Trans>
        </Button>
      </DialogActions>
    </>
  );
};

export default RemoveCompleteShareCodeDialog;
